module.exports = __webpack_public_path__ + "static/media/cg.ca1bd739.svg";